// extracted by mini-css-extract-plugin
export default {"formControl":"OTO_rtN","formTitle":"REj6cyE","formDesc":"BKBD968"};